export default "__VITE_ASSET__2nMnCrWx__"